import type { OriginalRootState } from 'redux/rootReducer'

/** Returns the account type indicator for logged in user */
export const selectAccountIndicator = (state: OriginalRootState) =>
  state.loginInfo.accountIndicator

/** Returns user update success flag. */
export const selectIsUserUpdateSuccess = (state: OriginalRootState) =>
  state.loginInfo.isUpdateSuccess

/** Returns user update pending flag */
export const selectIsUserUpdatePending = (state: OriginalRootState) =>
  state.loginInfo.isUserUpdatePending

/** Returns userInfo (from profiles endpoint) from the authentication (aka loginInfo) slice. */
export const selectUserInfo = (state: OriginalRootState) =>
  state.loginInfo.userInfo

/** Returns true if user must complete or verify MFA Contact Info */
export const selectIsContactUpdateRequired = (state: OriginalRootState) => {
  return selectUserInfo(state)?.contactUpdateRequired
}

/** Returns isLoading flag from authentication (aka loginInfo) slice */
export const selectIsAuthLoading = (state: OriginalRootState) =>
  state.loginInfo.isLoading

/** Returns the logged in users unique login id. */
export const selectUserID = (state: OriginalRootState) => state.loginInfo.userID

/** Returns the logged in users unique account id. */
export const selectAccountId = (state: OriginalRootState) =>
  state.loginInfo.accountId

export const selectIsInvalidAccount = (state: OriginalRootState) =>
  state.loginInfo.errorMessage === 'invalid.sams.account.type'

/** Returns the firstTimeLogin flag */
export const selectFirstTimelogon = (state: OriginalRootState) =>
  state.loginInfo.firstTimeLogon

export const selectJwt = (state: OriginalRootState) => state.loginInfo.jwtToken

export const selectSessionIdFromLogin = (state: OriginalRootState) =>
  state.loginInfo.sessionId
